// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"7a7d8ae8","288":"ea56b1ec","558":"ed8a23bd","635":"fe0b6d1c","793":"a3456be7"}[chunkId] + ".chunk.js";
};